var $ = require('jquery')
  , X_OFFSET = 30
  , Y_OFFSET = 25

function ifDefinedOr(value, defaultValue) {
  return value !== void 0 ? value : defaultValue
}

function View(element) {
  this.$el = element
  this.xOffset = ifDefinedOr(this.$el.data('mini-tip-x-offset'), X_OFFSET)
  this.yOffset = ifDefinedOr(this.$el.data('mini-tip-y-offset'), Y_OFFSET)
}

View.prototype.listen = function() {
  this.$el
    .mousemove($.proxy(function(e) {
      var x = e.pageX + this.xOffset
        , y = e.pageY + this.yOffset
        , tips = this.tips()

      tips.css({ left: x, top: y }).show()
    }, this))
    .mouseleave($.proxy(function() {
      this.tips().hide()
    }, this))
}

View.prototype.tips = function() {
  var body = $('body')

  if (!this.tipElementHasCreated) {
    this.tipElement = $('<div>', {
      'class': 'tooltip'
    })

    var tipRawHtmlTmpl = this.$el.data('mini-tip-tmpl')

    this.tipElement
      .css({ position: 'absolute' , zIndex: '544' })

    if (!tipRawHtmlTmpl) {
      this.tipElement.text(this.$el.data('mini-tip'))
    } else {
      this.tipElement.html(
        $('script#' + tipRawHtmlTmpl).html()
      )
    }

    body.append(this.tipElement)
    this.tipElementHasCreated = true
  }

  return this.tipElement
}

View.prototype.render = function() {
  if (!this.$el.is('[data-mini-tip]')) { return }
  this.disableBrowserNativeTooltip()
  this.listen()
}

View.prototype.disableBrowserNativeTooltip = function() {
  if (!this.$el.is('a')) { return }
  this.$el.removeAttr('title')
}

View.applyWithIn = function(selector, context) {
  context = context || document

  $(context).find(selector).each(function(i, el) {
    var widget = new View($(el), context)
    widget.render()
  })
}

module.exports = View
